export const isPathEnabled = (pathname: string, paths: string[]): boolean => {
  if (!paths.length) return false;

  return paths.some((pattern) => {
    if (pattern === '/*') return true;

    if (pattern.endsWith('/*')) {
      const basePath = pattern.slice(0, -1);
      return pathname.startsWith(basePath);
    }
    return pathname === pattern;
  });
};
